import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { MobileAppBanner } from "./";
import { selectHeaderCommonData, selectHttpCookie, selectHttpHeaders } from "../../store/common";
import { selectHeaderTheme, selectIsRegionConfirmationShow } from "../../store/slices/layout/selectors";
export var MobileAppBannerRC = compose(connect(function (state) {
  return {
    banner: selectHeaderCommonData(state).mobileAppBanner,
    cookie: selectHttpCookie(state),
    headers: selectHttpHeaders(state),
    headerTheme: selectHeaderTheme(state),
    shouldRender: !!selectHeaderCommonData(state).mobileAppBanner && !selectIsRegionConfirmationShow(state)
  };
}), withRenderFlag)(MobileAppBanner);